import { render, staticRenderFns } from "./RouterLinkEhdollinen.vue?vue&type=template&id=3adb33ef&scoped=true&"
import script from "./RouterLinkEhdollinen.vue?vue&type=script&lang=js&"
export * from "./RouterLinkEhdollinen.vue?vue&type=script&lang=js&"
import style0 from "./RouterLinkEhdollinen.vue?vue&type=style&index=0&id=3adb33ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb33ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3adb33ef')) {
      api.createRecord('3adb33ef', component.options)
    } else {
      api.reload('3adb33ef', component.options)
    }
    module.hot.accept("./RouterLinkEhdollinen.vue?vue&type=template&id=3adb33ef&scoped=true&", function () {
      api.rerender('3adb33ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RouterLinkEhdollinen.vue"
export default component.exports